import { render, staticRenderFns } from "./receivables.vue?vue&type=template&id=3a31147b&scoped=true&"
import script from "./receivables.vue?vue&type=script&lang=js&"
export * from "./receivables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31147b",
  null
  
)

export default component.exports